import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'

import { firestorePlugin } from 'vuefire'
import { init } from './firebase.js'
Vue.use(firestorePlugin)

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

import moment from 'moment';
import 'moment/locale/fr';
moment.locale('fr');

import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
Vue.component('icon', Icon)

Vue.config.productionTip = false

let app = null;
init.then(() => {
  if(!app) {
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount('#app')
  }
}).catch((error) => {
  //TODO: Activate Vue app too then redirect
  console.log(error)
  document.getElementById("loader-spinner").style.display = "none"
  document.getElementById("loader-text").innerHTML = 'Impossible de se connecter<br/><br/><button type="button" class="btn btn-outline-warning" onclick="window.location.reload()">Réessayer</button>'
})
